<template>
  <permission-gate
    moduleKey="solicitud"
    :showNoEditAlert="true"
  >
    <template #default="{ canEdit }">
      <main-breadcrumb
        :items="items"
        showBackButton
      ></main-breadcrumb>
      <main-buttons-bar :align="'space-between'">
        <template #left>
          <custom-title>Edición de solicitud</custom-title>
        </template>
        <template
          v-if="canEdit"
          #right
        >
          <el-button
            type="default"
            size="default"
            :icon="IconContentCopy"
            @click="openCloneModal"
          >
            Copiar solicitud
          </el-button>
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            style="margin-right: 1rem"
            @click="openModalRequest"
            >Agregar elemento</el-button
          >
        </template>
      </main-buttons-bar>

      <modal-select-product-type
        v-model="modalVisible"
        title="Nueva solicitud"
        url="/page/requests/edit"
        @close-modal="() => (modalVisible = false)"
      />

      <modal-clone-request
        v-if="modalVisibleClone"
        v-model="modalVisibleClone"
        :selectedRow="selectedCloneRow"
        @closed="modalVisibleClone = false"
        @cloned="onCloned"
      />

      <et-diferencias-modal
        v-model="modalDiferenciasEtVisible"
        :diferencias="diferenciasEt"
        :bloqueado-por-propuesta="bloqueadoPorPropuestaEt"
        :loading="loadingActualizarEt"
        @update="actualizarEt"
      />

      <detail-container>
        <loading-overlay :show="isLoading" />

        <div class="detail-container">
          <el-row :gutter="24">
            <el-alert
              v-if="solicitud.isDesactualizado"
              class="alerta-banner-dark"
              type="warning"
              effect="dark"
              show-icon
              :closable="false"
            >
              <template #default>
                <div class="banner-content">
                  <div class="banner-text">
                    <span class="banner-title">Versión de ET Desactualizada</span>
                    <span class="banner-description">
                      Esta solicitud utiliza la versión <strong>V{{ solicitud.VersionET }}</strong
                      >. Existe una versión más reciente (<strong
                        >V{{ solicitud.versionVigente }}</strong
                      >) disponible.
                    </span>
                  </div>
                  <el-button
                    class="banner-button"
                    size="default"
                    @click="abrirDiferenciasEt"
                  >
                    <template #icon>
                      <IconVectorDifference />
                    </template>
                    Ver cambios
                  </el-button>
                </div>
              </template>
            </el-alert>
            <custom-data
              :label="'Nro de solicitud'"
              :spanColumn="3"
              :data="solicitud?.Codigo"
            />
            <el-col
              v-if="solicitud.CodigoCotizacion"
              :span="3"
            >
              <div class="label">Nro. de Cotizacion</div>
              <router-link
                :to="`/page/prices/edit/${solicitud.CodigoCotizacion}`"
                class="cotizacion-link"
              >
                {{ solicitud.CodigoCotizacion }}
              </router-link>
            </el-col>
            <el-col :span="7">
              <div class="custom-label">Cliente/Prospecto</div>
              <el-autocomplete
                v-model="solicitud.Cliente.Descripcion"
                size="default"
                :value-key="'Descripcion'"
                :class="{ 'input-error': !validarSolicitudCampos.CodigoCliente }"
                :fetch-suggestions="handleSearch"
                clearable
                placeholder="Ingresar el cliente"
                style="width: 100%"
                @select="handleClientSelect"
              />
            </el-col>
            <custom-select
              v-model="solicitud.EstadoSolicitud"
              :label="'Estado'"
              :spanColumn="4"
              :settings="{
                placeholder: 'Seleccionar estado',
                options: estadoSolicitudList,
                disabled: true,
              }"
              @update:modelValue="handleEstado"
            >
            </custom-select>
            <custom-data
              :label="'Fecha estado'"
              :spanColumn="2"
              :data="solicitud.FechaEstado ? getDate('dd/mm/yyyy', solicitud.FechaEstado) : ''"
            />
            <custom-data
              :label="'Fecha creacion'"
              :spanColumn="2"
              :data="solicitud.FechaCreacion ? getDate('dd/mm/yyyy', solicitud.FechaCreacion) : ''"
            />
            <custom-data
              :label="'Fecha Modificación'"
              :spanColumn="3"
              :data="
                solicitud.FechaActualizacion
                  ? getDate('dd/mm/yyyy', solicitud.FechaActualizacion)
                  : ''
              "
            />
            <custom-data
              :label="'Vendedor'"
              :spanColumn="3"
              :data="`${solicitud.Cliente?.UsuarioVendedorPrincipal?.Nombre || ''} ${
                solicitud.Cliente?.UsuarioVendedorPrincipal?.Apellido || ''
              }`"
            />
          </el-row>
          <el-row :gutter="24">
            <custom-input
              v-model="solicitud.Referencia"
              :label="'Descripción'"
              :spanColumn="10"
              :settings="{
                placeholder: 'Ingrese la descripción del producto',
                inputClass: { 'input-error': !validarSolicitudCampos.Referencia },
              }"
            />
            <custom-select
              v-model="solicitud.Moneda"
              :label="'Moneda'"
              :spanColumn="4"
              :settings="{
                placeholder: 'Seleccionar moneda',
                inputClass: { 'input-error': !validarSolicitudCampos.CodigoMoneda },
                options: monedaList,
              }"
            />
          </el-row>
          <el-row :gutter="24">
            <el-col :span="4">
              <div class="custom-label">Adjuntos</div>
              <el-upload
                class="upload-list"
                :file-list="fileList"
                :auto-upload="true"
                multiple
                :http-request="uploadAdjuntoSolicitud"
                accept=".jpg,.png,.pdf,.txt"
                :on-remove="handleRemoveSolicitud"
                :on-preview="handlePreviewAdjunto"
              >
                <el-button
                  class="button-container-upload"
                  type="primary"
                  size="default"
                  ><IconUpload></IconUpload> Subir adjuntos</el-button
                >
              </el-upload>
            </el-col>
            <custom-select
              v-model="solicitud.Usabilidad"
              :label="'Usabilidad'"
              :spanColumn="4"
              :settings="{
                placeholder: 'Seleccionar aplicación',
                options: usabilidadLista,
              }"
              @update:modelValue="handleUsabilidad"
            />
            <custom-select
              v-model="solicitud.UnidadVenta"
              :label="'Unidad venta'"
              :spanColumn="6"
              :settings="{
                placeholder: 'Seleccionar unidad',
                inputClass: { 'input-error': !validarSolicitudCampos.CodigoUnidadVenta },
                options: unidadesMedida,
              }"
              @update:modelValue="handleUnidadVentaChange"
            />
          </el-row>

          <el-row
            :gutter="24"
            style="margin-top: 20px"
          >
            <el-col>
              <grilla-simplificada-solicitud
                :cantidades="solicitud.SolicitudCantidad"
                :precision="precisionCantidades"
                :has-error="!validarSolicitudCampos.SolicitudCantidad"
                @add-cantidad="requestStore.addCantidad"
                @remove-cantidad="requestStore.removeCantidad"
                @update-cantidad="requestStore.updateCantidad"
              />
            </el-col>
          </el-row>

          <InputProductosTerminados
            v-if="ElementoTipoSeleccionado.Codigo"
            :productos="solicitud.SolicitudProducto"
            :codigoCliente="(solicitud.Cliente && solicitud.Cliente.Codigo) || null"
            :codigoElementoGrupo="elementoGrupo?.Codigo || null"
            :validacionesCantidades="requestStore.validarSumatoriaCantidades"
            :precision="precisionCantidades"
            @add-producto="requestStore.addProducto"
            @remove-producto="requestStore.removeProducto"
            @update-producto="requestStore.updateProducto"
          />

          <input-deliveries
            :deliveries="solicitud.SolicitudEntregas"
            :precision="precisionCantidades"
            @add-delivery="requestStore.addEntrega"
            @remove-delivery="requestStore.removeEntrega"
            @update-delivery="requestStore.updateEntrega"
          />

          <div
            v-for="(elemento, index) in modelo"
            :key="index"
          >
            <!-- <span>
          Componente  {{ getComponenteDinamico(elemento.ElementoTipo.CodigoElementoBase) }}
        </span> -->
            <component
              :is="getComponenteDinamico(elemento.ElementoTipo.CodigoElementoBase)"
              v-if="configReady && elemento.ElementoTipo?.CodigoElementoBase"
              v-model="modelo[index]"
              :title="`${elemento.ElementoTipo.Descripcion} ${index + 1}`"
              :name="`${elemento.ElementoTipo.Descripcion}${index}`"
            />
          </div>

          <el-divider />
          <el-row :gutter="20">
            <custom-input
              v-model="solicitud.Observaciones"
              :label="'Observaciones de cotización'"
              :spanColumn="12"
              :settings="{
                placeholder: 'Observaciones de cotización',
                maxlength: 800,
                showWordLimit: true,
              }"
            />
            <custom-input
              v-model="solicitud.Notas"
              :label="'Notas Internas'"
              :spanColumn="12"
              :settings="{
                placeholder: 'Notas de uso local ',
                maxlength: 800,
                showWordLimit: true,
              }"
            />
          </el-row>
          <div
            v-if="canEdit"
            class="container"
          >
            <custom-confirm-buttons
              :disabled="
                [EstadoSolicitud.PENDIENTE, EstadoSolicitud.A_COTIZAR].includes(
                  solicitud.CodigoEstado,
                )
                  ? false
                  : true
              "
              :confirmDisabled="solicitud.CodigoEstado === EstadoSolicitud.COTIZADA"
              :showLoading="false"
              :confirmText="'Guardar'"
              :cancelText="'Cancelar'"
              :isSolicitud="true"
              @on-cancel="onCancel"
              @on-confirm="handleSave"
              @on-anular="onAnular"
            />
          </div>
          <div v-if="canEdit">
            <div
              v-if="
                solicitud.CodigoEstado !== EstadoSolicitud.A_COTIZAR &&
                solicitud.CodigoEstado !== EstadoSolicitud.COTIZADA &&
                solicitud.CodigoEstado !== EstadoSolicitud.ACEPTADA &&
                solicitud.CodigoEstado !== EstadoSolicitud.RECHAZADA
              "
              class="container"
            >
              <el-button
                type="primary"
                size="default"
                @click="sendCotizar"
              >
                <IconPeso /> Grabar y enviar a cotizar</el-button
              >
            </div>
            <div
              v-if="
                solicitud.CodigoCotizacion !== null &&
                solicitud.CodigoEstado == EstadoSolicitud.COTIZADA
              "
              class="container"
            >
              <el-button
                type="primary"
                size="default"
                @click="printPdfPropuestaComercial"
                ><IconPrint />&nbsp;Propuesta comercial</el-button
              >
            </div>
          </div>
        </div>
      </detail-container>
    </template>
  </permission-gate>
</template>

<script setup>
import {
  ref,
  onMounted,
  onBeforeMount,
  onUnmounted,
  computed,
  provide,
  watch,
} from 'vue';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import { storeToRefs } from 'pinia';
import { ElNotification } from 'element-plus';
import { useRequestStore } from '@/views/requests/stores/request_store.js';
import { useProspectStore } from '@/views/prospects/stores/prospect_store.js';
// import { useSeccionesStore } from '@/stores/secciones_store'
import { useEstadoSolicitudStore } from '@/stores/estado-solicitud.js';
import { useUsabilidadStore } from '@/stores/usabilidad/usabilidad_store.js';
import { useMateriaPrimaFamiliaStore } from '@/stores/materia_prima_familia/materia_prima_familia_store';
import { useMonedaStore } from '@/stores/moneda/moneda_store';
import { useUnidadMedidaStore } from '@/stores/unidad_medida/unidad_medida_store';
import { useElementoGrupoStore } from '@/stores/elemento_grupo/elemento_grupo_store';
import { ElementoBase } from '@/enum/elemento_base';
import { useElementoBaseStore } from '@/stores/elemento_base/elemento_base_store';

import { Modules } from '@/enum/modules';
import {
  precisionCantidad,
  redondearCantidadesLista,
} from '@/shared/utils/cantidad_unidad_venta.js';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import LoadingOverlay from '@/shared/LoadingOverlay.vue';
import CustomData from '@/shared/components/custom_data.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import IconUpload from '~icons/mdi/cloud-upload';
import IconContentCopy from '~icons/mdi/content-copy';
import IconAdd from '~icons/mdi/add';
import IconPeso from '~icons/mdi/dollar';
import IconPrint from '~icons/mdi/printer-outline';
import getDate from '@/shared/components/utils.js';
import IconVectorDifference from '~icons/mdi/vector-difference-ba';
import { useAdjuntosUpload } from '@/shared/composables/useAdjuntosUpload.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { obtenerCodigoUsuario } from '@/shared/utils/get_user_code.js';
import InputProductosTerminados from '@/shared/components/input_productos_terminados.vue';
import InputDeliveries from '@/shared/components/input_deliveries.vue';
import GrillaSimplificadaSolicitud from './components/grilla_simplificada_solicitud.vue';
import ModalSelectProductType from '@/shared/components/modal_select_product_type.vue';
import ModalCloneRequest from '@/views/requests/request_list/modal_clone_request.vue';
import EtDiferenciasModal from '@/shared/components/et_diferencias_modal.vue';
import request_elemento_model from '../models/request_elemento_model';
import { useElementos } from '@/shared/composables/useElementos.js';
import { useModulo } from '@/shared/composables/useModulo.js';
import { EstadoSolicitud } from '@/enum/estado_solicitud';
import { useConfiguracionStore } from '@/stores/configuracion-general.js';
import PermissionGate from '@/shared/components/permission_gate.vue';
import { describirCamposInvalidos } from '@/shared/utils/validacion_campos.js';
import { provideErrorRegistry } from '@/shared/composables/use_error_registry.js';
import { notificarErroresValidacion } from '@/shared/utils/notificar_errores_validacion.js';

provide('currentModule', Modules.SOLICITUD);
const elementoBaseEtiquetas = computed(
  () => elementoBaseStore.elementoBaseConfig?.etiquetas ?? null,
);
provide('elementoBaseEtiquetas', elementoBaseEtiquetas);

const { tieneErrores, mensajes: mensajesErrores } = provideErrorRegistry();

const requestStore = useRequestStore();
const prospectStore = useProspectStore();
// const seccionesStore = useSeccionesStore()
const estadoSolicitudStore = useEstadoSolicitudStore();
const usabilidadStore = useUsabilidadStore();
const materiaPrimaFamiliaStore = useMateriaPrimaFamiliaStore();
const monedaStore = useMonedaStore();
const unidadMedidaStore = useUnidadMedidaStore();

const elementoGrupoStore = useElementoGrupoStore();
const { elementoGrupo } = storeToRefs(elementoGrupoStore);

const { firstEstadoSolicitud } = estadoSolicitudStore;
const { estadoSolicitudList } = storeToRefs(estadoSolicitudStore);

const { monedaList } = storeToRefs(monedaStore);

const { unidadesMedida } = storeToRefs(unidadMedidaStore);

const { solicitud, validarSolicitudCampos } = storeToRefs(requestStore);
const { usabilidadLista } = storeToRefs(usabilidadStore);
const precisionCantidades = computed(() => precisionCantidad(solicitud.value.CodigoUnidadVenta));

// Obtener componentes para el módulo actual
const { getComponenteDinamico } = useModulo(Modules.SOLICITUD);

const configuracionStore = useConfiguracionStore();
const { uploadPublicFileHTTP } = configuracionStore;
const { sellado, solapa } = storeToRefs(configuracionStore);

const elementoBaseStore = useElementoBaseStore();

const { searchProspectsHTTP } = prospectStore;
const {
  resetSolicitud,
  resetValidaciones,
  updateSolicitudHTTP,
  createSolicitudHTTP,
  findSolicitudPorCodigoHTTP,
  validarCampos,
  validarCamposCotizacion,
  newRequestToPriceHTTP,
  validarCantidades,
  getDiferenciasEtHTTP,
  actualizarEtHTTP,
} = requestStore;
// const { firstSecciones } = seccionesStore
const route = useRoute();
const router = useRouter();
const modalVisibleClone = ref(false);
const modalVisibleRequest = ref(false);
const isCreatingRequest = ref(false);
const modalVisible = ref(false);
const selectedCloneRow = ref(null);
const ElementoTipoSeleccionado = ref({});
const configReady = ref(false);

const { modelo, initializeModelo, isLoading, standardToModuleArray } = useElementos();

const items = [
  { label: 'Inicio', to: '/page/requests/list', replace: false },
  { label: 'Edición', to: null, replace: false },
];

const uploadToken = ref((crypto?.randomUUID && crypto.randomUUID()) || String(Date.now()));
const API_BASE = import.meta.env.VITE_URL_BASE_API || import.meta.env.VITE_URL_BASE || '';

const solicitudAdjuntoAdapter = {
  getAdjuntos: () => solicitud.value.SolicitudAdjunto,
  setAdjuntos: (next) => (solicitud.value.SolicitudAdjunto = next),

  getSubdir: () => {
    const code = solicitud.value?.Codigo;
    return code ? `adjuntos/solicitud` : `adjuntos/solicitud/tmp/${uploadToken.value}`;
  },

  buildAdjunto: ({ relPath, nextItem }) => ({
    Codigo: null,
    CodigoSolicitud: solicitud.value?.Codigo ?? null,
    ItemAdjunto: nextItem,
    Url: relPath,
  }),
};

const {
  fileList,
  uploadAdjunto: uploadAdjuntoSolicitud,
  handleRemove: handleRemoveSolicitud,
  hydrateFileListFromModel,
} = useAdjuntosUpload({
  uploadPublicFileHTTP,
  apiBase: API_BASE,
  adapter: solicitudAdjuntoAdapter,
});

const openCloneModal = () => {
  selectedCloneRow.value = JSON.parse(JSON.stringify(solicitud.value));
  modalVisibleClone.value = true;
};

const modalDiferenciasEtVisible = ref(false);
const diferenciasEt = ref([]);
const bloqueadoPorPropuestaEt = ref(false);
const loadingActualizarEt = ref(false);

const abrirDiferenciasEt = async () => {
  try {
    const data = await getDiferenciasEtHTTP(solicitud.value.Codigo);
    diferenciasEt.value = data?.diferencias || [];
    bloqueadoPorPropuestaEt.value = !!data?.bloqueadoPorPropuesta;
    modalDiferenciasEtVisible.value = true;
  } catch (err) {
    console.error(err);
    useMessageError().open('Ocurrió un error al obtener las diferencias de la ET.');
  }
};

const actualizarEt = async ({ actualizarTodos, camposAActualizar }) => {
  loadingActualizarEt.value = true;
  try {
    await actualizarEtHTTP(solicitud.value.Codigo, { actualizarTodos, camposAActualizar });
    await findSolicitudPorCodigoHTTP(solicitud.value.Codigo);
    await initializeModelo(solicitud.value.SolicitudElemento, Modules.SOLICITUD);
    useMessageSuccess().open('Los datos se actualizaron correctamente.');
    modalDiferenciasEtVisible.value = false;
  } catch (err) {
    console.error(err);
    useMessageError().open('Ocurrió un error al actualizar los datos.');
  } finally {
    loadingActualizarEt.value = false;
  }
};

const openModalRequest = () => {
  isCreatingRequest.value = false;
  modalVisibleRequest.value = true;
};

function handleUnidadVentaChange(item) {
  solicitud.value.CodigoUnidadVenta = item?.Codigo ?? null;
  const precision = precisionCantidad(solicitud.value.CodigoUnidadVenta);
  const productos = solicitud.value.SolicitudProducto || [];
  const listas = [
    solicitud.value.SolicitudCantidad,
    solicitud.value.SolicitudEntregas,
    ...productos.map((p) => p.SolicitudProductoCantidad),
    productos,
  ];
  const huboCambios = listas
    .map((lista) => redondearCantidadesLista(lista, precision))
    .some(Boolean);
  if (huboCambios) {
    ElNotification({
      title: 'Cantidades',
      message: 'La unidad de venta no admite decimales: las cantidades se redondearon a enteros.',
      type: 'warning',
    });
  }
}

const handlePreviewAdjunto = (file) => {
  const url = file?.url;
  if (!url) return;
  window.open(url, '_blank', 'noopener');
};

const handleSearch = async (query, cb) => {
  let results = [];
  if (query && query.length >= 3 && query !== 'null') {
    results = await searchProspectsHTTP(query);
  }
  cb(results || []);
};

const handleClientSelect = async (item) => {
  if (item && item.Codigo) {
    solicitud.value.Cliente = item;
    solicitud.value.CodigoCliente = item.Codigo;
  }
};

const printPdfPropuestaComercial = () => {
  if (solicitud.value && solicitud.value.CodigoCotizacion) {
    const pdfPath = `/${solicitud.value.CodigoCotizacion}_PropuestaComercial.pdf`;
    window.open(pdfPath, '_blank');
  } else {
    console.error('Código no disponible');
  }
};

function handleEstado() {
  solicitud.value.FechaEstado = getDate('yyyy/mm/dd');
  solicitud.value.CodigoEstado = solicitud.value.EstadoSolicitud?.Codigo ?? null;
}

function handleUsabilidad(item) {
  solicitud.value.CodigoUsabilidad = item.Codigo;
}

const onCancel = () => {
  resetSolicitud();
  router.go(-1);
};

const onAnular = async () => {
  solicitud.value.Estado = {
    Codigo: 5,
    Descripcion: '',
  };
  await handleSave();
};

const preSaveCheck = () => {
  const elementosMapeados = standardToModuleArray(modelo.value, Modules.SOLICITUD);
  elementosMapeados.forEach((elemento) => {
    if (Array.isArray(elemento.SolicitudElementoProceso)) {
      elemento.SolicitudElementoProceso = elemento.SolicitudElementoProceso.filter(
        (proceso) => !proceso.MarcadoParaEliminacion,
      );
    }
  });
  solicitud.value.SolicitudElemento = elementosMapeados;

  if (!validarCampos()) {
    ElNotification({
      title: 'Revisar formulario',
      message: describirCamposInvalidos(requestStore.camposSolicitudInvalidos),
      type: 'error',
    });
    return false;
  }
  if (!validarCantidades()) {
    ElNotification({
      title: 'Revisar formulario',
      message: 'Debe ingresar al menos una cantidad a cotizar',
      type: 'warning',
    });
    return false;
  }
  if (!requestStore.cantidadesValidadas) {
    ElNotification({
      title: 'Cantidades inválidas',
      message:
        'La sumatoria de las cantidades en el detalle no coincide con las cantidades a cotizar.',
      type: 'error',
    });
    return false;
  }

  // COTI-633: registro de errores reportados por los componentes hijos (procesos,
  // materiales, pliego vs. máximo de máquina...) — reemplaza los chequeos puntuales
  // que antes vivían acá uno por uno.
  if (tieneErrores.value) {
    notificarErroresValidacion(mensajesErrores.value);
    return false;
  }

  // TODO: implementar validacion de porcentajes en extrusion

  return true;
};

const sendCotizar = async () => {
  if (!preSaveCheck()) {
    return;
  }

  // TODO (COTI-507): falta el control de porcentajes de extrusión antes de cotizar
  // (que los tornillos sumen 100 % y que cada proceso multimaterial también).
  // La implementación previa estaba deshabilitada y referenciaba `isExtrusion` /
  // `extrusionRef`, que no existen en este componente; se quitó por eso.

  const saved = await save();

  if (!saved) {
    throw new Error('No se pudo obtener el código de la solicitud guardada.');
  }

  const {
    data: { Codigo },
  } = saved;

  useLoading().openLoading(); // Abre el indicador de carga al inicio
  try {
    // Guardar o actualizar la solicitud primero
    await findSolicitudPorCodigoHTTP(Codigo);
    solicitud.value.CodigoEstado = 6;
    solicitud.value.EstadoSolicitud = {
      Activo: true,
      Codigo: 6,
      Descripcion: 'A Cotizar',
    };

    // Procede a enviar la solicitud a cotización
    await newRequestToPriceHTTP();
    router.push('/page/requests/list');
  } catch (err) {
    // Manejo de errores
    useMessageError().open(
      `Ha ocurrido un error al intentar procesar la solicitud: ${err.message || ''}`,
    );
  } finally {
    // Cierra el indicador de carga al finalizar
    useLoading().closeLoading();
  }
};

const handleSave = async () => {
  if (!preSaveCheck()) {
    return;
  }

  useLoading().openLoading();

  try {
    const saved = await save();
    let codigoSaved = solicitud.value.Codigo;
    if (saved) {
      codigoSaved = saved?.data?.Codigo || saved?.Codigo || codigoSaved;
    }
    if (codigoSaved) {
      await findSolicitudPorCodigoHTTP(codigoSaved);
      await initializeModelo(solicitud.value.SolicitudElemento, Modules.SOLICITUD);
      if (!route.params.id) {
        router.replace({ path: `/page/requests/edit/${codigoSaved}` });
      }
    }

    useMessageSuccess().open(`Los datos se guardaron exitosamente!`);
  } catch (err) {
    console.error('Error en handleSave:', err);
  } finally {
    useLoading().closeLoading();
  }
};

const save = async () => {
  try {
    if (!solicitud.value.Codigo) {
      return await createSolicitudHTTP();
    } else {
      return await updateSolicitudHTTP();
    }
  } catch (err) {
    console.error(err);
    useMessageError().open(`Ha ocurrido un error al intentar guardar los datos.`);
  }
};

const onCloned = (cloned) => {
  router.push(`/page/requests/edit/${cloned.solicitud}`);
};
const loadSolicitud = async (id) => {
  useLoading().openLoading();
  try {
    configReady.value = false;
    resetValidaciones();

    await findSolicitudPorCodigoHTTP(id);

    ElementoTipoSeleccionado.value = solicitud.value?.SolicitudElemento?.[0]?.ElementoTipo;
    if (ElementoTipoSeleccionado.value) {
      localStorage.setItem(
        'tipoProductoSeleccionado',
        JSON.stringify(ElementoTipoSeleccionado.value),
      );
      await elementoBaseStore.findElementoBaseConfigHTTP(
        ElementoTipoSeleccionado.value.CodigoElementoBase,
        Modules.SOLICITUD,
      );
    }
    await initializeModelo(solicitud.value.SolicitudElemento, Modules.SOLICITUD);
    solicitud.value.CodigoEstado = solicitud.value.EstadoSolicitud?.Codigo;

    hydrateFileListFromModel();

    if (ElementoTipoSeleccionado.value?.Codigo) {
      unidadMedidaStore.emptyList();
      unidadMedidaStore.findAllUnidadMedidaHTTP({
        EsUnidadVenta: true,
        page: 0,
        Activo: true,
        CodigoElementoTipo: ElementoTipoSeleccionado.value.Codigo,
      });

      usabilidadStore.emptyList();
      usabilidadStore.findAllUsabilidadHTTP({
        page: 0,
        CodigoElementoTipo: ElementoTipoSeleccionado.value.Codigo,
      });
    }
    configReady.value = true;
  } catch (err) {
    console.error(err);
    useMessageError().open('No se pudo cargar la solicitud seleccionada.');
  } finally {
    useLoading().closeLoading();
  }
};
onMounted(() => {
  const id = Number(route.params?.id || 0);
  solicitud.value.CodigoEstado = solicitud.value.EstadoSolicitud?.Codigo;
  if (!id) {
    solicitud.value.FechaEstado = getDate('yyyy/mm/dd');
  }
});

onBeforeMount(async () => {
  configReady.value = false;

  await configuracionStore.findAllConfiguracionesHTTP({ page: 1 });
  firstEstadoSolicitud();
  resetValidaciones();
  monedaStore.emptyList();
  monedaStore.findAllMonedaHTTP({ page: 0, Activo: true });
  unidadMedidaStore.emptyList();
  materiaPrimaFamiliaStore.emptyList();
  usabilidadStore.emptyList();

  const id = route.params.id;

  if (id && +id > 0) {
    await loadSolicitud(id);
  } else {
    ElementoTipoSeleccionado.value = elementoGrupo.value.ElementoGrupoDetalle[0].ElementoTipo;
    if (!elementoGrupo.value || !elementoGrupo.value.Codigo) {
      ElNotification({
        title: 'Error',
        message: 'Debe seleccionar un grupo de elementos antes de crear una solicitud.',
        type: 'error',
      });
      router.push('/page/requests/list');
      return;
    }
    solicitud.value.SolicitudElemento = elementoGrupo.value.ElementoGrupoDetalle.map((egd) => {
      return {
        ...JSON.parse(JSON.stringify(request_elemento_model)),
        ElementoTipo: egd.ElementoTipo,
      };
    });

    const selladoDefault = sellado.value;
    const solapaDefault = solapa.value;

    solicitud.value.SolicitudElemento.forEach((elemento, index) => {
      if (index === 0) {
        if (
          elemento.Sellado === 0 &&
          ElementoTipoSeleccionado.value.CodigoElementoBase === ElementoBase.BOLSAS_BOX
        ) {
          elemento.Sellado = selladoDefault;
        }
        if (
          elemento.Solapa === 0 &&
          [ElementoBase.BOLSAS_FUELLE, ElementoBase.BOLSAS_BOX].includes(
            ElementoTipoSeleccionado.value.CodigoElementoBase,
          )
        ) {
          elemento.Solapa = solapaDefault;
        }
      }
    });

    await requestStore.setDefaults(elementoGrupo.value.Codigo);
    await elementoBaseStore.findElementoBaseConfigHTTP(
      ElementoTipoSeleccionado.value.CodigoElementoBase,
      Modules.SOLICITUD,
    );
    await initializeModelo(solicitud.value.SolicitudElemento, Modules.SOLICITUD);
    configReady.value = true;
    unidadMedidaStore.emptyList();
    unidadMedidaStore.findAllUnidadMedidaHTTP({
      EsUnidadVenta: true,
      page: 0,
      Activo: true,
      CodigoElementoTipo: ElementoTipoSeleccionado.value.Codigo,
    });

    materiaPrimaFamiliaStore.findAllfamiliaMaterialHTTP({
      page: 0,
      sortBy: 'Descripcion',
      sort: 'asc',
    });

    usabilidadStore.findAllUsabilidadHTTP({
      page: 0,
      CodigoElementoTipo: ElementoTipoSeleccionado.value.Codigo,
    });
  }
});

watch(
  () => route.params.id,
  async (newId, oldId) => {
    if (newId && newId !== oldId) {
      modalVisibleClone.value = false;
      selectedCloneRow.value = null;
      await loadSolicitud(newId);
    }
  },
);

onUnmounted(() => {
  resetSolicitud();
});
</script>

<style scoped>
.et-alert-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.et-alert-button {
  flex-shrink: 0;
}

.detail-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}

.custom-label {
  font-weight: 700;
  color: #111;
}

.container {
  display: flex;
  justify-content: flex-end;
}

.input-wrapper {
  display: inline-block;
  margin-right: 10px;
}

.cotizacion-link {
  color: blue;
  text-decoration: none;
  cursor: pointer;
}
.alerta-banner-dark {
  margin-bottom: 20px;
}

:deep(.el-alert__content) {
  width: 100%;
}

.banner-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.banner-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #ffffff;
}

.banner-title {
  font-size: 14px;
  font-weight: bold;
}

.banner-description {
  font-size: 13px;
}

.banner-button {
  color: var(--el-color-warning);
  font-weight: 600;
  border: none;
}

.banner-button:hover {
  color: var(--el-color-warning-light-3);
  background-color: var(--el-color-warning-light-9);
}
</style>
